<template>
  <Section id="sales">
    <template v-slot:header>
      <span></span>
      <ToggleNSFW v-model="nsfw" v-if="hasNsfw"/>
    </template>
    <ShuffleGrid>
      <ShuffleCard v-for="shuffle in nftList" :key="shuffle.id" :shuffle="shuffle"/>
    </ShuffleGrid>
    <infinite-loading spinner="waveDots" @infinite="infiteListHandler" :identifier="infiniteId" :forceUseInfiniteWrapper="true"><span slot="no-more"></span>
      <span slot="no-results">
        <template v-if="id">
            <h4>This user doesn't have any active shuffles</h4>
          </template>
          <template v-else>
            <h4>You don't have any active shuffles. Create one <router-link to="/shuffle/create">here</router-link></h4>
          </template>
      </span>
    </infinite-loading>
    <ContractPopUp v-if='displayContractPopUp' :_kind="contractKind" :_price='contractPrice' :_is-algo=false :_tokenId='contractTokenId' @done='() => {}' @close="displayContractPopUp = false" :_isAlgo="isContractAlgo"></ContractPopUp>
  </Section>
</template>

<script>
import { mapState } from 'vuex'
import Section from '@/components/Layout/Section'
import InfiniteLoading from 'vue-infinite-loading'
import ShuffleCard from '@/components/Shuffle/ShuffleCard'
import ContractPopUp from '@/components/Common/PopUp/ContractPopUp'
import ShuffleGrid from '@/components/Shuffle/ShuffleGrid'
import ToggleNSFW from '@/components/Common/Button/ToggleNSFW'

export default {
  name: 'UserShuffles',
  components: { ToggleNSFW, ShuffleGrid, ShuffleCard, Section, InfiniteLoading, ContractPopUp },
  props: ['id'],
  data: () => {
    return {
      nftList: [],
      infiniteId: 0,
      increment: 16,
      contractKind: '',
      contractPrice: 1,
      contractTokenId: 0,
      isContractAlgo: true,
      displayContractPopUp: false,
      nsfw: false,
      hasNsfw: false
    }
  },
  computed: {
    ...mapState([
      'userId',
      'wallet'
    ]),
    galleryId () {
      return this.id || this.userId
    },
    salesUrl () {
      return '/api/shuffle'
    }
  },
  watch: {
    nsfw () {
      this.reload()
    }
  },
  methods: {
    reload () {
      this.nftList = []
      this.infiniteId++
    },
    newContract (data) {
      this.contractKind = data.kind
      this.contractPrice = data.price
      this.contractTokenId = data.tokenId
      this.isContractAlgo = true
      this.displayContractPopUp = true
    },
    infiteListHandler ($state) {
      const url = this.salesUrl
      this.$http.get(url, {
        params: {
          start: this.nftList.length,
          end: this.nftList.length + this.increment,
          nsfw: this.nsfw,
          user: this.galleryId
        }
      }).then(({ data }) => {
        if (data?.metadata.length) {
          this.nftList.push(...data.metadata)
          $state.loaded()
        } else {
          $state.complete()
        }
      })
    }
  },
  mounted () {
    this.$http.get(this.salesUrl, {
      params: {
        start: 0,
        end: 1,
        nsfw: true,
        user: this.galleryId
      }
    }).then(({ data }) => {
      if (data?.metadata.length) this.hasNsfw = true
    })
  }
}
</script>

<style scoped>
.card-grid {
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  grid-auto-rows: 85px;
}
</style>
